import {useQuery} from 'react-query'
import api from '../api'

export const useGetAvailabilityPatchesQuery = () => {
  return useQuery(['getAvailabilityPatches'], () => api.getAvailabilityPatches(), {
    keepPreviousData: true,
  })
}
